/**
 * Close the current paragraph of a streaming assistant turn.
 *
 * One chat turn can span several LLM calls: the model says something, calls a
 * tool, then speaks again with the result. Every `bot:chunk` of all of them is
 * concatenated into a single `streamingText`, with nothing between the segments
 * — so the bubble read "Now I'll search for flights for you.Here are the
 * flights I found for…", two sentences fused at the full stop. The backend
 * persists one assistant message per LLM call, so a page reload showed the same
 * turn as two separate bubbles and the live stream as one run-on paragraph.
 *
 * A tool call is what separates two segments, so the caller invokes this on
 * `bot:searching`.
 *
 * Idempotent: several tool calls can fire back-to-back with no text between
 * them, and a boundary must not stack blank lines.
 */
export function appendSegmentBreak(streamingText: string): string {
  if (!streamingText || streamingText.endsWith('\n\n')) return streamingText;
  return `${streamingText.trimEnd()}\n\n`;
}
